// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const Environment = {
  Local: {
    Application: "Tenant App Local",
    production: false,
    Env: "Local-",
    CloudApiHost: "http://localhost:7200/TenantCloud",
    AccountApiHost: "http://localhost:5000/account",
    SocketEndpoint: 'http://localhost:5050',
    IPayEndpoint: 'https://payment.ipay88.com.my/epayment/entry.asp',
    IPayResponseURL: 'https://localhost:4200/TenantApp/payment/payment-result',
    IPayBackendURL: 'https://localhost:7200/TenantCloud/payment/ipay88'
  },
  Dev: {
    Application: "Tenant App",
    production: false,
    Env: "Dev-",
    CloudApiHost: "https://dev.rentx.my/TenantCloud",
    AccountApiHost: "https://dev.rentx.my/account",
    SocketEndpoint: 'https://dev.rentx.my/',
    IPayEndpoint: 'https://payment.ipay88.com.my/epayment/entry.asp',
    IPayResponseURL: 'https://dev.rentx.my/TenantApp/payment/payment-result',
    IPayBackendURL: 'https://dev.rentx.my/TenantCloud/payment/ipay88'
  },
  Uat: {
    Application: "Tenant App",
    production: false,
    Env: "Uat-",
    CloudApiHost: "https://dev.rentx.my/TenantCloud",
    AccountApiHost: "https://dev.rentx.my/account",
    SocketEndpoint: 'https://dev.rentx.my/',
    IPayEndpoint: 'https://payment.ipay88.com.my/epayment/entry.asp',
    IPayResponseURL: 'https://dev.rentx.my/TenantApp/payment/payment-result',
    IPayBackendURL: 'https://dev.rentx.my/payment/ipay88'
  },
  Prod: {
    Application: "Tenant App",
    production: false,
    Env: "",
    // CloudApiHost: "https://api.lease365.my/tenant",
    // AccountApiHost: "https://api.lease365.my/account",
    // SocketEndpoint: 'https://api.lease365.my/',
    // IPayEndpoint: 'https://payment.ipay88.com.my/epayment/entry.asp',
    // IPayResponseURL: 'https://tenant.lease365.my/payment/payment-result',
    // IPayBackendURL: 'https://api.lease365.my/tenant/payment/ipay88'
    CloudApiHost: "https://tms.smebank.com.my/tenantCloudApi",
    AccountApiHost: "https://tms.smebank.com.my/accountApi",
    SocketEndpoint: 'https://tms.smebank.com.my/',
    IPayEndpoint: 'https://payment.ipay88.com.my/epayment/entry.asp',
    IPayResponseURL: 'https://tms.smebank.com.my/tenant_app/payment/payment-result',
    IPayBackendURL: 'https://tms.smebank.com.my/tenantCloudApi/payment/ipay88'
  },
};

export const environment = Environment.Dev;
